import styled from 'styled-components'
import { SlideInModal } from 'syf-component-library/ui/patterns/SlideInModal'
import { isSafari } from 'helpers'
import query from 'mediaQueries'
import { colors, opacities } from 'const/colors'
import Icon from 'ui/atoms/Icon'
import { ClientPalette } from 'typings/brands'

/** Returns css linear-gradient for the navigation modal */
const navBackgroundGradient = ({
  theme
}: {
  theme: ClientPalette
}) => `linear-gradient(
  349deg,
  ${theme.headerMenu.backgroundColorStart} 1%,
  ${theme.headerMenu.backgroundColorEnd} 99%
)`

export const NavigationModal = styled(SlideInModal)`
  width: 78%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 2px 32px 0 ${opacities.greyEightyTwo};
  background-image: ${navBackgroundGradient};
  z-index: 3;
  &:after {
    z-index: 2;
  }
`

/*
 *     Support: Mobile Safari
 * Description: Bottom menu bar covers bottom-most links when visible.
 *         Fix: Allocate +44px of bottom spacing to account for menu bar.
 */
export const MobileMenuContainer = styled.ul`
  height: 100%;
  margin: 0;
  padding: ${isSafari() ? '16px 16px 80px' : '16px'};
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  line-height: 2.29;
  z-index: 1;
`

export const MenuClose = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  padding: 0;
  border: none;
  background: none;
  height: 15px;
  width: 15px;
`

export const CloseIcon = styled(Icon)`
  font-size: 24px;
  color: ${colors.white};
  cursor: pointer;
`

export const MenuContainerWrapper = styled.div`
  display: none;
  @media ${query.greaterThanMedium} {
    display: block;
    position: relative;
  }
`

export const MenuContainer = styled.ul<{ styleType?: string }>`
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0 25px;
  border-top: 0.5px solid ${opacities.greyEightyOne};
  box-shadow: 0 2px 7px 0 ${opacities.greyEightyOne};
  list-style-type: ${({ styleType }): string => styleType || 'none'};
  & > li:not(:first-child) {
    margin-left: 5px;
  }
  background-color: ${colors.white};
  height: 42px;
`
